module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon-toast-完成.7816d.png";